export default __webpack_public_path__ + "static/media/btc.7fa921ee.png";